import { Epic, ofType } from 'redux-observable';
import { EMPTY, Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { Action } from '../../actions';
import { SAVE_IMPORT_WIZARD, SaveImportWizard } from '../../actions/importWizard/saveImportWizard';
import {
    SaveImportWizardSuccess,
    saveImportWizardSuccessAction
} from '../../actions/importWizard/saveImportWizardSuccess';
import {
    UploadFileImportWizard,
    uploadFileImportWizardAction
} from '../../actions/importWizard/uploadFileImportWizard';
import {
    UploadImagesImportWizard,
    uploadImagesImportWizardAction
} from '../../actions/importWizard/uploadImagesImportWizard';
import { EpicDeps } from '../../service/StoreFactory';
import { ImportWizardPhase } from '../../typings/importWizard';
import { State } from '../../typings/state';

type EpicActions = UploadFileImportWizard | UploadImagesImportWizard | SaveImportWizardSuccess;

export const saveImportWizardEpic: Epic<Action, Action, State, EpicDeps> = (action$, store) => {
    return action$.pipe(
        ofType(SAVE_IMPORT_WIZARD),
        switchMap(
            (action: SaveImportWizard): Observable<EpicActions> => {
                const state = store.value;

                switch (state.importWizard.phase) {
                    case ImportWizardPhase.FILE_UPLOAD:
                        return of(uploadFileImportWizardAction());
                    case ImportWizardPhase.IMAGE_UPLOAD:
                        return of(uploadImagesImportWizardAction());
                    case ImportWizardPhase.VALIDATION:
                        return of(saveImportWizardSuccessAction());
                    default:
                        return EMPTY;
                }
            }
        )
    );
};
